import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHome"><Path d="M3.5 8.84247L12 2L20.5 8.84247V20.5H3.5V8.84247Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconHome;
